import {
  NBS_API_GET_MY_FAVORITES_SUCCESS,
  NBS_API_BLOCK_USER_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS,
} from '../../constants/actions';

const initialState = {
  data: [],
  lastUserId: '',
  end: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_MY_FAVORITES_SUCCESS:
      const currentState = { ...state };
      const { users, end } = action.response;
      const lastUserId =
        end || !users || !users.length ? '' : users[users.length - 1].user_id;

      if (action.silent) {
        return { lastUserId, end, data: [...users] };
      } else {
        return { lastUserId, end, data: [...currentState.data, ...users] };
      }
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const currentUsers = [...state.data];
      const newUsers = currentUsers.filter(
        (user) => user.user_id !== action.userId
      );
      return { ...state, data: newUsers };
    default:
      return state;
  }
}
